import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { subdomainListResp } from '@biz-models/network/account-model-network';
import { L7Response } from '@biz-models/network/l7-response.model';
import { subdomainUnlinkResp } from '@biz-models/network/login-authenticate-network.model';
import { AuthenticationToken } from '@biz-selectors/app.selectors';
import { userToken } from '@biz-store/auth/feature.selectors';
import { Store } from '@ngrx/store';
import { combineLatest, filter } from 'rxjs';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { ApiService } from 'src/controls/api/shared/api.service';
import { AjaxService } from './ajax.service';
const _MICROSERVICE = 'sso-ms';
@Injectable({
	providedIn: 'root',
})
export class RegisterService {
	test: any;
	private message$ = new BehaviorSubject(null);
	message = this.message$.asObservable();

	constructor(
		private ajax: AjaxService,
		private window: Window,
		private store: Store,
		private apiService: ApiService,
	) {}

	register(data): Observable<any> {
		return this._register('auth/register', data);
	}

	registerFacebook(data): Observable<any> {
		return this._register('auth/register', data);
	}

	invitedUser(data): Observable<any> {
		return this.ajax.post(
			'user',
			'invite/user/register/' + data.token + '?_subdomain=' + data.subdomain,
			data,
		);
	}

	checkSubdomain(data): Observable<any> {
		return this.ajax.post('sso', 'auth/domain/check/', data);
	}

	listofLinkedAccount() {
		return this.ajax.get('sso', 'token/');
	}

	listSubdomain() {
		return this.apiService.get$<L7Response<subdomainListResp[]>>(_MICROSERVICE, 'auth/identity/tenants');
	}

	private _register(url, data) {
		return this.ajax.post('sso', url, data).pipe(
			tap({
				next: (res) => this.registerSuccess(data, res),
			}),
		);
	}

	private registerSuccess(data, res) {
		if (!res.data) return;
		// emit success
		this.message$.next(res.data);
		// backward compatible payload
		let old_payload = {
			BIZTORY: {
				subdomain_name: res.data.subdomain,
				id: res.data.id,
				path: null,
				data: {
					name: data.name,
					phone: data.hp,
					email: data.email,
					company_name: data.company_name,
					referrer_name: data.referrer_name,
					referrer_phone: data.referrer_phone,
					// "id": 16889,
					// "ip": "10.0.0.36"
				},
				version: 'Master',
				status: 1,
				biztory_plan: 'm',
				// "free_trial_end": 1620363002,
				// "created_at": "2021-04-07T12:50:02+08:00",
				// "updated_at": "2021-04-07T12:50:18+08:00"
			},
			USER: {
				// "password": "$2y$10$bKJK6.\/DrX6jlL44MeSVbujyq1LXdPolA5LbqA7XXTMBnXQtEvDNq"
			},
		};
		// gtm event
		if (window['dataLayer']) {
			window['dataLayer'].push({
				...old_payload,
				event: 'registrationComplete',
			});
		}
		// tapfiliate
		console.trace();
		if (window['tap']) {
			console.log('service');
			console.log(window['tap']);
			window['tap']('trial', res.data.subdomain, {
				meta_data: {
					$name: data.company_name,
					company_name: data.company_name,
					$email: data.email,
					$phone: '+6' + data.hp.replace('-', ''),
				},
			});
			console.log('tap entered');
		}
	}
}
